import { render, staticRenderFns } from "./OemPackageCard.vue?vue&type=template&id=8cb7b384"
import script from "./OemPackageCard.vue?vue&type=script&lang=js"
export * from "./OemPackageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports